import { addNavMenuSection } from '@vendure/admin-ui/core';

export default [
  addNavMenuSection(
    {
      id: 'quatru-customers-section',
      label: 'Utilizadores',
      items: [
        {
          id: 'customers-tab',
          label: 'Utilizadores',
          routerLink: ['/extensions/customers'],
          icon: 'user'
        }
      ]
    },
    'customers'
  )
];
